export class FormsHelper {

	static setAndRememberInputValue = (id, value, deflt) => {
		const input = document.getElementById(id)
		if (value) {
			input.value = value
			localStorage.setItem(id, value)
		}
		else {
			const oldValue = localStorage.getItem(id)
			if (oldValue) {
				input.value = oldValue
			}
			else if (deflt) {
				input.value = deflt
			}
			else {
				input.value = ''
			}
		}
	}

}